
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              Golden Twin Towers
            </h3>
            <p className="text-gray-300 mb-4">
              Your Strategic Gateway to K-Beauty's Global Future
            </p>
            <p className="text-gray-400 text-sm">
              Empowering beauty brands through trusted partnerships, compliance, and innovation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('home');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-[#C8A654] transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('brands');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-[#C8A654] transition-colors cursor-pointer"
                >
                  Brand Distribution
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('oem-odm');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-[#C8A654] transition-colors cursor-pointer"
                >
                  OEM/ODM Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('about');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-300 hover:text-[#C8A654] transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-mail-line text-[#C8A654] mr-3"></i>
                <span className="text-gray-300">info@goldentwintowers.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line text-[#C8A654] mr-3"></i>
                <span className="text-gray-300">London, United Kingdom</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C8A654] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C8A654] transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#C8A654] transition-colors cursor-pointer">
                <i className="ri-phone-line"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Partners Section */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <h4 className="text-lg font-semibold mb-4 text-center">Our Trusted Partners</h4>
          <div className="grid md:grid-cols-2 gap-4 max-w-2xl mx-auto">
            <div className="text-center">
              <p className="text-gray-400 text-sm">Manufacturing Partner</p>
              <p className="text-[#C8A654] font-medium">Natuzen Co., Ltd.</p>
            </div>
            <div className="text-center">
              <p className="text-gray-400 text-sm">Core Brand Partner</p>
              <p className="text-[#C8A654] font-medium">Celina Co., Ltd. (Minicell)</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © 2024 Golden Twin Towers Ltd. All rights reserved. | 
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#C8A654] hover:text-[#B8964A] ml-1 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
